// extracted by mini-css-extract-plugin
export var numberInputContainer = "_5u-0";
export var startPickingButton = "_5u-1";